import { Offer, PropertyAddress } from 'types/property';
import { get } from 'lodash';

export interface CampaignGeoConfig {
  excludeTargetLocation: boolean;
  addressPropertyKey: string;
  targetLocation: string[];
  pointsDisclaimerSymbol: string;
  promotionalSashMessage: string;
}

export interface CampaignDisclaimerAndPromotionMessage {
  disclaimerSymbol: string;
  campaignSpecificPromotionMessage: string;
}

export const getCampaignDisclaimerAndPromotionMessage = (
  isStandardCampaignEnabled: boolean,
  propertyAddress?: PropertyAddress,
  isGeoTargeted?: boolean,
  campaignGeoConfig?: CampaignGeoConfig | null,
): CampaignDisclaimerAndPromotionMessage => {
  let disclaimerSymbol: string = '^';
  let campaignSpecificPromotionMessage: string = '';

  const showDifferentDisclaimerSymbol = isStandardCampaignEnabled && isGeoTargeted;

  if (showDifferentDisclaimerSymbol && campaignGeoConfig && propertyAddress) {
    const propertyAddressValue: string = propertyAddress[campaignGeoConfig.addressPropertyKey];
    const isTargetLocation: boolean = campaignGeoConfig.targetLocation.includes(propertyAddressValue);

    if (campaignGeoConfig.excludeTargetLocation) {
      if (!isTargetLocation) {
        disclaimerSymbol = campaignGeoConfig.pointsDisclaimerSymbol;
        campaignSpecificPromotionMessage = campaignGeoConfig.promotionalSashMessage;
      }
    } else {
      if (isTargetLocation) {
        disclaimerSymbol = campaignGeoConfig.pointsDisclaimerSymbol;
        campaignSpecificPromotionMessage = campaignGeoConfig.promotionalSashMessage;
      }
    }
  }

  return {
    disclaimerSymbol,
    campaignSpecificPromotionMessage,
  };
};

export const getPromotionalSashMessage = (
  offer: Offer,
  globalCampaignDefaultSash?: string | undefined,
  campaignSpecificPromotionMessage?: string | undefined,
): string => {
  const isClassic = offer?.type === 'classic';
  const useGlobalCampaignDefaultSash = globalCampaignDefaultSash && !isClassic;

  let promotionSash = '';
  if (useGlobalCampaignDefaultSash) {
    promotionSash = globalCampaignDefaultSash;
  } else if (campaignSpecificPromotionMessage && !isClassic) {
    promotionSash = campaignSpecificPromotionMessage;
  } else {
    promotionSash = get(offer, 'promotion.name') ?? '';
  }

  if (promotionSash === 'Featured' && offer.luxOffer) {
    return `Featured \u2022 Luxury Offer`;
  } else {
    return promotionSash;
  }
};
